import { UiBox } from "@smp/ui";
import clsx from "clsx";

import { IStickerMeta } from "../../../hooks";
import classes from "./sticker_preview.module.css";

export const StickerPreview = ({
  src,
  meta,
}: {
  src?: string;
  meta?: IStickerMeta;
}) => (
  <UiBox
    className={clsx(classes.wrapper, { [classes.preview_fallback]: !src })}
  >
    {src && (
      <img
        src={src}
        alt={meta?.desc}
        title={meta?.name}
        className={classes.preview_image}
      />
    )}
  </UiBox>
);
